import React, { useState } from 'react';
import SignUp from '../components/SignUp';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import NavbarHeader from '../components/NavbarHeader';

function SignupPage() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <ScrollToTop />
      <NavbarHeader toggle={toggle} />
      <SignUp />
      <Footer />
    </>
  );
}

export default SignupPage;
